import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export enum ProgressMode {
  DETERMINATE = 'determinate',
  INDETERMINATE = 'indeterminate',
}

@Component({
  selector: 'app-loading-v2',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-v2.component.html',
  styleUrls: ['./loading-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingV2Component {
  constructor(public translateService: TranslateService) {}

  readonly ProgressMode = ProgressMode;
  /** SVG coordinate system size — display size is controlled by CSS. */
  readonly spinnerViewBoxSize = 64;
  readonly spinnerViewBox = `0 0 ${this.spinnerViewBoxSize} ${this.spinnerViewBoxSize}`;
  readonly spinnerCenter = this.spinnerViewBoxSize / 2;
  readonly spinnerRadius = 27;
  readonly spinnerCircumference = Math.PI * 2 * this.spinnerRadius;

  @Input() mode: ProgressMode = ProgressMode.INDETERMINATE;
  @Input() progress: number = 0;
  @Input() showMessage = true;
  @Input() message = this.translateService.instant('Please wait, this may take some time');

  @HostBinding('class.loading-v2--full-parent')
  @Input()
  fullParent = false;

  @HostBinding('style.--app-loading-v2-message-show-delay')
  get messageShowDelayInSecondsStyle(): string {
    return `${this.messageShowDelay}s`;
  }

  // delay showing the loading message (in seconds)
  @Input() messageShowDelay = 12;
}
